(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ltt-whats-inside-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.ltt-wic[data-section-id]');
    sections.forEach(initCarousel);

    function initCarousel(section) {
      const track = section.querySelector('.ltt-wic__track');
      if (!track) return;

      const arrows = section.querySelectorAll('.ltt-wic__arrow');
      const dots = section.querySelectorAll('.ltt-wic__dot');
      const cards = Array.from(track.querySelectorAll('.ltt-wic__card'));
      if (cards.length === 0) return;

      function getScrollAmount() {
        const card = cards[0];
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        return card.offsetWidth + gap;
      }

      function getActiveIndex() {
        const scrollLeft = track.scrollLeft;
        let activeIndex = 0;
        let minDistance = Infinity;
        cards.forEach((card, i) => {
          if (dots[i] && dots[i].style.display === 'none') return;
          const distance = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = i;
          }
        });
        return activeIndex;
      }

      function updateDotVisibility() {
        const maxScroll = track.scrollWidth - track.clientWidth;
        cards.forEach((card, i) => {
          if (!dots[i]) return;
          const cardOffsetInTrack = card.offsetLeft - track.offsetLeft;
          const isReachable = cardOffsetInTrack <= maxScroll + 5;
          dots[i].style.display = isReachable ? '' : 'none';
        });
      }

      function updateUI() {
        updateDotVisibility();

        const activeIndex = getActiveIndex();
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === activeIndex);
        });

        const maxScroll = track.scrollWidth - track.clientWidth;
        const hasOverflow = maxScroll > 1;
        arrows.forEach(arrow => {
          if (!hasOverflow) {
            arrow.disabled = true;
            return;
          }
          if (arrow.dataset.direction === 'prev') {
            arrow.disabled = track.scrollLeft <= 1;
          } else {
            arrow.disabled = track.scrollLeft >= maxScroll - 1;
          }
        });
      }

      arrows.forEach(arrow => {
        arrow.addEventListener('click', () => {
          const amount = getScrollAmount();
          const direction = arrow.dataset.direction === 'next' ? 1 : -1;
          track.scrollBy({ left: amount * direction, behavior: 'smooth' });
        });
      });

      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index, 10);
          const card = cards[index];
          if (card) {
            track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        });
      });

      let scrollTimeout;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateUI, 80);
      });

      window.addEventListener('resize', updateUI);
      updateUI();

      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) * 1000;
      if (autoplay && autoplaySpeed > 0) {
        let timer = setInterval(advance, autoplaySpeed);

        function advance() {
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= maxScroll - 1) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          }
        }

        section.addEventListener('mouseenter', () => clearInterval(timer));
        section.addEventListener('focusin', () => clearInterval(timer));
        section.addEventListener('mouseleave', () => {
          clearInterval(timer);
          timer = setInterval(advance, autoplaySpeed);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
